module.exports = __webpack_public_path__ + "img/test_Icon5.758ae99b.png";